import React from "react";
import {
  HighchartsChart,
  Chart,
  XAxis,
  YAxis,
  Title,
  Legend,
  Tooltip,
  ColumnSeries
} from "react-jsx-highcharts";

// Create a column chart to display size distributions
const getXAxis = (unit) => {
  return {
    categories: [
      "<" + unit,
      1*unit + "-" + 2*unit,
      2*unit + "-" + 3*unit,
      3*unit + "-" + 4*unit,
      4*unit + "-" + 5*unit,
      5*unit + "-" + 6*unit,
      6*unit + "-" + 7*unit,
      7*unit + "-" + 8*unit,
      8*unit + "-" + 9*unit,
      9*unit + "-" + 10*unit,
      ">" + 10*unit
    ]
  }
}
const lineChart = props => (
  <div>
    <HighchartsChart>
      <Chart type={"column"} />
      <Legend layout="horizontal" align="center" verticalAlign="bottom" />

      <Title>{props.title}</Title>
      <XAxis type={"category"} {...getXAxis(props.xAxisUnit[0]/10)} >
        <XAxis.Title> Weight [g] </XAxis.Title>
        {/*Setup the vertical Plotlines that show the scanners boundries*/}
      </XAxis>
      <YAxis id="number">
        <YAxis.Title> Fish Counted [pc] </YAxis.Title>
        {/*Create the Reggression Lines the slop is not included atm */}
        {props.distributionChart.map((Bars, index) => (
          <ColumnSeries
            key={index}
            id={`${props.ChannelName[index]}`}
            data={Bars}
            name={props.ChannelName[index]}
            pointWidth={30}
          />
        ))}
      </YAxis>
      <Tooltip padding={10} hideDelay={250} shape="square" />
    </HighchartsChart>
    <button onClick={props.exportToCSV}>Export to CSV</button>
  </div>
);

export default lineChart;
